export const formatPrice: (price?: number | null) => string = (price) => {
    if (price === undefined || price === null) {
        return '';
    }

    return Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(price).replace(/\s/g, '');
};

export const formatFiscalNumber: (fiscalNumber: string) => string = (fiscalNumber) => {
    return fiscalNumber.replace(/.{3}/g, '$& ');
};

export const formatPhoneNumber: (phoneNumber: string) => string = (phoneNumber) => {
    const normalizedPhoneNumber = removeWhiteSpaces(phoneNumber);

    let localPart: string | null = null;

    if (/^\+351\d{9}$/.test(normalizedPhoneNumber)) {
        localPart = normalizedPhoneNumber.slice(4); // remove +351
    } else if (/^00351\d{9}$/.test(normalizedPhoneNumber)) {
        localPart = normalizedPhoneNumber.slice(5); // remove 00351
    } else if (/^351\d{9}$/.test(normalizedPhoneNumber)) {
        localPart = normalizedPhoneNumber.slice(3); // remove 351
    } else if (/^\d{9}$/.test(normalizedPhoneNumber)) {
        // local number only (do not add +351)
        return normalizedPhoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
    }

    if (localPart) {
        return '+351 ' + localPart.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3');
    }

    return normalizedPhoneNumber;
};

export const formatMultibancoReference: (reference: string) => string = (reference) => {
    return reference.replace(/.{3}/g, '$& ');
};

// yyyy-mm-dd
export const formatDateForAPI: (dateObj: Date) => string = (dateObj) => {
    if (!isNaN(dateObj.getTime())) {
        return (
            dateObj.getFullYear() + '-' + ('0' + (dateObj.getMonth() + 1)).slice(-2) + '-' + ('0' + dateObj.getDate()).slice(-2)
        );
    }
    return '';
};

// dd/mm/yyyy
export const formatDate: (date: string | null) => string = (date) => {
    if (date === null) {
        return '';
    }

    const dateObj = new Date(date);
    if (!isNaN(dateObj.getTime())) {
        return (
            ('0' + dateObj.getDate()).slice(-2) + '/' + ('0' + (dateObj.getMonth() + 1)).slice(-2) + '/' + dateObj.getFullYear()
        );
    }
    return date;
};

export const formatTime: (date: string) => string = (date) => {
    const dateObj = new Date(date);
    if (!isNaN(dateObj.getTime())) {
        return ('0' + dateObj.getHours()).slice(-2) + ':' + ('0' + dateObj.getMinutes()).slice(-2);
    }
    return date;
};

export const formatDateTime: (date: string) => string = (date) => {
    return formatDate(date) + ' ' + formatTime(date); 
};

// cspell:disable-next-line
// 17 Março
export function formatDateToDayMonth(date: Date, locale: string): string {
    const formatter = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: 'long',
    });
  
    const parts = formatter.formatToParts(date);
  
    const day = parts.find(p => p.type === 'day')?.value ?? '';
    const month = parts.find(p => p.type === 'month')?.value ?? '';
  
    // capitalize
    const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
  
    return `${day} ${cap(month)}`;
}

// cspell:disable-next-line
// Quinta-feira, 17 Março
export function formatDateToLongLocalized(date: Date, locale: string): string {
    const formatter = new Intl.DateTimeFormat(locale, {
        weekday: 'long',
    });
  
    const parts = formatter.formatToParts(date);
  
    const weekday = parts.find(p => p.type === 'weekday')?.value ?? '';
  
    // capitalize
    const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
  
    return `${cap(weekday)}, ${formatDateToDayMonth(date, locale)}`;
}

export const formatPtPostalCodeInput: (postalCode: string) => string = (postalCode) => {
    postalCode = postalCode.replace(/[^0-9-]/g, '');

    if (postalCode.length > 4 && !postalCode.includes('-')) {
        postalCode = `${postalCode.slice(0, 4)}-${postalCode.slice(4)}`;
    }

    if (postalCode.length > 8) {
        postalCode = postalCode.slice(0, 8);
    }

    return postalCode;
}

export const formatPtPhoneNumberInput: (phoneNumber: string) => string = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

    // max is 9 digits
    if (phoneNumber.length > 9) {
        phoneNumber = phoneNumber.slice(0, 9);
    }

    if (phoneNumber.length <= 3) {
        return `${phoneNumber.slice(0, 3)}`;
    } else if (phoneNumber.length <= 6) {
        return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3, 6)}`;
    }

    return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6)}`;
}

export const removeWhiteSpaces: (text: string) => string = (text) => {
    return text.replace(/\s+/g, '');
}

export const removeNonLetters: (text: string) => string = (text) => {
    return text.replace(/[^a-zA-Z\s]/g, '');
}

export const simplifyUrl: (url: string) => string = (url) => {
    return url
        .replace(/^https?:\/\//, '') // remove http:// or https://
        .replace(/\/$/, ''); // // remove trailing slash
}
